import { render, staticRenderFns } from "./TheAddressBookGuideModal.vue?vue&type=template&id=82bc552c&scoped=true"
import script from "./TheAddressBookGuideModal.vue?vue&type=script&lang=js"
export * from "./TheAddressBookGuideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bc552c",
  null
  
)

export default component.exports